import React from "react"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import DialogContent from "@material-ui/core/DialogContent"
import VerbViewLogo from "../../../static/images/VerbViewLogo.png"
import VerbCharts from "../../components/VerbView/VerbCharts"
import Typography from "@material-ui/core/Typography"
import VerbViewDiagram from "../../../static/images/VerbViewDiagram.jpeg"

import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    fontSize: "small",
    color: "white",
  },
  definition: {
    fontWeight: "bold",
  },
  dialogRef: {
    color: "grey",
    fontSize: "80%",
    textAlign: "center",
    marginBottom: "-15px",
  },
  dialogHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-10px",
  },
  logo: {
    height: "30px",
    width: "auto",
  },
  VVDiagram: {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  VVimage: {
    maxHeight: "50px",
    width: "auto",
  },
  closeButtonHolder: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))

const VerbViewDialog = props => {
  console.log(props)
  const classes = useStyles()
  const verbRef = props.verbDialog.content.VerbView.refNum
  const testament = verbRef.substring(0, 1) === "G" ? "NT" : "OT"
  const dictionary =
    testament === "NT"
      ? require(`../../data/strongsGreekDictionary.json`)
      : testament === "OT"
      ? require(`../../data/strongsHebrewDictionary.json`)
      : null
  // const DJHVerb = getVerbRef(verbRef)
  const verbData = require(`../../data/Verbs/${verbRef}.json`)[verbRef]
  return (
    <Dialog
      maxWidth="lg"
      open={props.verbDialog.open}
      onClose={() => props.newVerbDialog({ open: false, content: {} })}
    >
      <DialogTitle>
        <div className={classes.dialogHeader}>
          <img src={VerbViewLogo} className={classes.logo} alt="VerbViewLogo" />
          <Typography variant="h4" className={classes.title}>
            VerbView
          </Typography>
          <div className={classes.closeButtonHolder}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={props.onClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        {`${dictionary[verbData.strongNum].lemma} (${
          verbData.transliteration
        }) : ${verbRef}`}
      </DialogTitle>
      <DialogContent dividers>
        <p className={classes.definition}>
          {`STRONG'S ${testament} #${verbData.strongNum.substring(
            1
          )} DEFINITION:  `}
          <em>
            {dictionary[verbData.strongNum]
              ? dictionary[verbData.strongNum].strongs_def
              : "N/A"}
          </em>
        </p>
        <div className={classes.VVDiagram}>
          <img
            src={VerbViewDiagram}
            className={classes.VVimage}
            alt="VerbView Diagram"
          />
        </div>
        <VerbCharts fileRef={verbRef} verbRef={verbRef} close={props.onClose} />
      </DialogContent>
    </Dialog>
  )
}

export default VerbViewDialog
